export default __webpack_public_path__ + "static/case-6-d5cf5fd5845ed1eedd658e126525bb8b.png";